import { Text } from '@src/design-system/text';
import { formatRelativeDate } from '../helpers/date-helper';
import { renderNotificationIcon } from '../helpers/notification-icon-helper';
import { useNotificationRead } from '../hooks/use-notification-read';

import type { TNotification } from '@src/shared/types/notification';
import type { FC } from 'react';

interface NotificationItemProps {
  data: TNotification;
}
export const NotificationItem: FC<NotificationItemProps> = ({ data }) => {
  const {
    id,
    title_en,
    message_en,
    created_at,
    entity_type,
    entity_id,
    meta_type,
    is_read,
    data: extraData,
  } = data;

  const { handleNotificationReadAndRedirection } = useNotificationRead();

  return (
    <div
      onClick={() =>
        handleNotificationReadAndRedirection({
          id,
          entity_type,
          entity_id,
          is_read,
          data: extraData,
        })
      }
      className={`flex items-center  gap-x-3 p-3 rounded-xl border border-[#EAE8EE]  hover:opacity-[.7] cursor-pointer transition
        ${is_read ? 'bg-white' : 'bg-gray-50'}`}
    >
      <div className='flex-shrink-0 w-6 h-6'>
        {renderNotificationIcon(meta_type)}
      </div>
      <div className='flex-1'>
        <Text
          variant='p'
          className='text-sm font-medium text-gray-900'
        >
          {title_en}
        </Text>
        <Text
          variant='p'
          className='text-xs text-gray-500'
        >
          {message_en}
        </Text>
      </div>
      <Text
        variant='span'
        className='text-xs text-gray-400 whitespace-nowrap'
      >
        {formatRelativeDate(created_at)}
      </Text>
    </div>
  );
};
